export default {
  messageType: '커머스',
  title: '커머스 설정',
  label: {
    title: '상품명',
    regularPrice: '정상가격',
    discountPrice: '할인가격',
    discountRate: '할인율',
    discountFixed: '정액할인가격',
    additionalContent: '부가설명',
    imageLink: '이미지 링크',
  },
  placeholder: {
    price: '0 ~ 99,999,999',
    fixed: '0 ~ 999,999',
    rate: '0 ~ 100',
    imageLink: '이미지 클릭 시 등록한 링크로 이동됩니다.',
  },
  comment: {
    image: '800x600 (4:3비율) 권장 / 최대 5MB',
    price: '할인 가격 입력시, 할인율 또는 정액할인가격 중 하나는 반드시 입력.',
    rate: '※ 할인율의 우선순위가 높습니다.',
  },
};
